import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ListLayout from "../../../../../../components/common/List/Custom-List_layout";
import { useGetNewProductRequestsQuery } from "../../../../../../store/api/AdminCatalogApi";
import ConfirmationModal from "../../../../../../components/common/List/DeletePopup";

const AdminRequestProductsList = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [filterValues, setFilterValues] = useState({});
  const [sortKey, setSortKey] = useState("created_at");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteid, setdeleteid] = useState({});
  const [pageSize, setPageSize] = useState(10);

  const { data: tabledata, isLoading, refetch } = useGetNewProductRequestsQuery({
    page: currentPage,
    page_size: pageSize,
    sort: sortKey,
    ...filterValues,
  });

  const handleDelete = async () => {
    try {
      // await delete action
      setIsModalOpen(false);
      refetch();
    } catch (error) {
      refetch();
    }
  };

  const handleSort = (key) => {
    if (sortKey !== key) setSortKey(key);
  };

  useEffect(() => {
    refetch();
  }, []);

  const tableHeaders = [
    { label: "Title", key: "title", sortable: true },
    { label: "UPC", key: "upc", sortable: true },
    {
      label: "Image",
      key: "main_image",
      render: (value) => {
        const imageUrl = value
          ? (value.startsWith("http") ? value : `${process.env.REACT_APP_STORE_API_URL}${value}`)
          : "/placeholder-image.png";
        return <img src={imageUrl} alt="product" className="w-12 h-12 object-cover rounded" />;
      }
    },
    {
      label: "Category",
      key: "categories",
      render: (value, row) => row.primary_category_name || "-"
    },
    {
      label: "Variants Count",
      key: "variants",
      render: (value) => value?.length || 0
    },
    {
      label: "Stock Records",
      key: "total_stock",
      sortable: true
    },
    {
      label: "Status",
      key: "status",
      sortable: true,
      render: (value) => {
        let colorClass = "bg-gray-200 text-gray-800";

        switch (value) {
          case "Approved":
            colorClass = "bg-green-100 text-green-700";
            break;
          case "Pending":
            colorClass = "bg-orange-100 text-orange-700";
            break;
          case "Rejected":
            colorClass = "bg-red-100 text-red-700";
            break;
          default:
            break;
        }

        return (
          <span
            className={`px-3 py-1.5 rounded-full text-xs font-semibold ${colorClass}`}
          >
            {value || "-"}
          </span>
        );
      },
    },
    {
      label: "Date Updated",
      key: "updated_at",
      sortable: true,
      render: (value) => new Date(value).toLocaleString()
    }
  ];

  const filters = [
    { key: "title", type: "text", placeholder: "Product Title" },
    { key: "upc", type: "text", placeholder: "UPC" },
    { key: "primary_category", type: "text", placeholder: "Category" },
  ];

  const filterComponents = filters.map((filter) => ({
    ...filter,
    value: filterValues[filter.key] || ""
  }));

  const handleFilterChange = (key, value) => {
    setFilterValues((prev) => ({ ...prev, [key]: value }));
    setCurrentPage(1);
  };

  const actionButtons = [
    {
      icon: "MdOutlineRemoveRedEye",
      // onClick: (row) => navigate("/product-view", { state: { data: row, pageName: "PRODUCT" } }),
      onClick: (row) => navigate(`/adminproduct-view/${row.id}/`, { state: { pageName: "PRODUCT" } }),

    },
    {
      icon: "MdOutlineModeEdit",
      onClick: (row) => navigate(`/edit-product/${row.id}/`, { state: { pageName: "PRODUCT" } }),
    },
    {
      icon: "RiDeleteBinLine",
      onClick: (row) => {
        setdeleteid(row);
        setIsModalOpen(true);
      },
    },
  ];

  const Buttons = [
    {
      title: "+ Add Product",
      design:
        "px-2 text-base py-1.5 bg-secondary font-normal text-white rounded hover:bg-secondary-700 flex items-center gap-1",
      onClick: () => navigate("/create-product", { state: { pageName: "PRODUCT" } }),
    },
  ];

  return (
    <>
      <ListLayout
        title="Products Request List"
        Buttons={Buttons}
        filterComponents={filterComponents}
        onFilterChange={handleFilterChange}
        tableHeaders={tableHeaders}
        tabledata={tabledata?.results || []}
        actionButtons={actionButtons}
        currentPage={currentPage}
        totalrecords={tabledata?.count}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onSort={handleSort}
        sortKey={sortKey}
        isLoading={isLoading}
      />

      {isModalOpen && (
        <ConfirmationModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onConfirm={handleDelete}
        />
      )}
    </>
  );
};

export default AdminRequestProductsList;
